import api from './base/standardApi';

export default {
  getCrmLogs( params: any ) {
    return api.get( 'api/synccrmlog/GetAll', params );
  },
};
